/* Fiche produit : galerie (tablette et ordinateur) et « Choisir mon pack » qui mène au bloc d'achat. */
(() => {
  const gallery = document.querySelector('.pdp-buy__gallery');
  if (gallery && !gallery.querySelector('.pdp-gallery__track')) {
    const imgs = Array.from(gallery.querySelectorAll('img'));
    gallery.classList.add('pdp-gallery');
    gallery.setAttribute('role', 'region');
    gallery.setAttribute('aria-roledescription', 'carrousel');
    gallery.setAttribute('aria-label', 'Photos du produit');
    const track = document.createElement('div');
    track.className = 'pdp-gallery__track';
    track.tabIndex = 0;
    imgs.forEach((img, i) => { img.loading = i ? 'lazy' : 'eager'; track.append(img); });
    const arrow = (dir) => `<button class="pdp-gallery__arrow pdp-gallery__arrow--${dir}" type="button" aria-label="${dir === 'prev' ? 'Photo précédente' : 'Photo suivante'}"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${dir === 'prev' ? 'm10 3-5 5 5 5' : 'm6 3 5 5-5 5'}"/></svg></button>`;
    gallery.append(track);
    gallery.insertAdjacentHTML('beforeend', `${arrow('prev')}${arrow('next')}<ol class="pdp-gallery__dots">${imgs.map((_, i) => `<li><button type="button" aria-label="Photo ${i + 1} sur ${imgs.length}"></button></li>`).join('')}</ol>`);
    const prev = gallery.querySelector('.pdp-gallery__arrow--prev');
    const next = gallery.querySelector('.pdp-gallery__arrow--next');
    const dots = Array.from(gallery.querySelectorAll('.pdp-gallery__dots button'));
    const index = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = (i) => track.scrollTo({ left: Math.max(0, Math.min(imgs.length - 1, i)) * track.clientWidth, behavior: 'smooth' });
    const sync = () => {
      const i = index();
      dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
      prev.disabled = i <= 0;
      next.disabled = i >= imgs.length - 1;
    };
    prev.addEventListener('click', () => go(index() - 1));
    next.addEventListener('click', () => go(index() + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') go(index() + 1); if (e.key === 'ArrowLeft') go(index() - 1); });
    const mq = window.matchMedia('(min-width: 750px)');
    const apply = () => { gallery.hidden = !mq.matches; sync(); };
    mq.addEventListener('change', apply);
    apply();
  }
  // Tableau de doses : bascule 1 pièce / 2 pièces
  document.querySelectorAll('[data-dose-btn]').forEach((btn) => btn.addEventListener('click', () => {
    const card = btn.closest('.pdp-sol__card');
    card.querySelector('.cg-dose').dataset.dose = btn.dataset.doseBtn;
    card.querySelectorAll('[data-dose-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
  }));

  // « Choisir mon pack » : défilement jusqu'au bloc d'achat
  document.querySelectorAll('a[href="#main"].pdp-pb__cta, a[data-to-buy]').forEach((a) => a.addEventListener('click', (e) => {
    const target = document.querySelector('.pdp-buy');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    const first = target.querySelector('input:checked, input, select');
    if (first) setTimeout(() => first.focus({ preventScroll: true }), 500);
  }));
})();

/* Avis clients : « Voir plus », tri, filtre par note, « Écrire un avis » (démonstration, rien n'est envoyé).
   Les 12 premiers avis sont dans la page ; tous les autres dans assets/data/avis/<produit>.js, chargé à la demande. */
(() => {
  const widget = document.querySelector('.cg-reviews[data-reviews]');
  if (!widget) return;
  const STEP = 12;
  const list = widget.querySelector('.cg-reviews__list');
  const more = widget.querySelector('.cg-reviews__more');
  const status = widget.querySelector('.cg-reviews__status');
  const sortBtn = widget.querySelector('[data-review-sort]');
  const menu = widget.querySelector('.cg-reviews__menu');
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.6 12.3 3 3 5.8-6" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const item = (r) => `<article class="cg-review">
    <p class="cg-review__name">${esc(r.n)}${r.v ? `<span class="cg-review__verified">${CHECK}Vérifié</span>` : ''}</p>
    <p class="cg-review__date"><time datetime="${esc(r.d)}">${esc(r.d.split('-').reverse().join('/'))}</time></p>
    <p class="cg-review__stars"><span class="cg-stars" style="--r:${Number(r.r)}" role="img" aria-label="${Number(r.r)} sur 5"></span></p>
    <p class="cg-review__text">${esc(r.t)}</p>${r.a ? `\n    <p class="cg-review__item"><span>Type d'article:</span>${esc(r.a)}</p>` : ''}
  </article>`;

  let all = null;
  let loading = null;
  let sort = 'vedette';
  let rating = 0;
  let shown = list.children.length;
  const load = () => {
    if (all) return Promise.resolve(all);
    if (!loading) loading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = widget.dataset.src;
      s.onload = () => { all = (window.CG_AVIS || {})[widget.dataset.reviews] || []; resolve(all); };
      s.onerror = () => { loading = null; reject(new Error('avis indisponibles')); };
      document.head.append(s);
    });
    return loading;
  };
  const byDate = (a, b) => b.d.localeCompare(a.d);
  const ORDER = { recent: byDate, haut: (a, b) => b.r - a.r || byDate(a, b), bas: (a, b) => a.r - b.r || byDate(a, b) };
  const view = () => {
    const v = all.filter((r) => !rating || r.r === rating);
    return ORDER[sort] ? [...v].sort(ORDER[sort]) : v;
  };
  const render = async (count, focusFrom = -1) => {
    widget.setAttribute('aria-busy', 'true');
    try { await load(); } catch { widget.removeAttribute('aria-busy'); return; }
    const v = view();
    shown = Math.min(count, v.length);
    list.innerHTML = v.slice(0, shown).map(item).join('');
    more.hidden = shown >= v.length;
    status.textContent = `${shown} avis affichés sur ${v.length}`;
    widget.removeAttribute('aria-busy');
    // « Voir plus » : le focus passe au premier avis ajouté
    const first = focusFrom >= 0 ? list.children[focusFrom] : null;
    if (first) { first.tabIndex = -1; first.focus({ preventScroll: true }); }
  };

  more.querySelector('button').addEventListener('click', () => render(shown + STEP, shown));

  widget.querySelectorAll('.cg-dist').forEach((btn) => btn.addEventListener('click', () => {
    const n = Number(btn.dataset.rating);
    rating = rating === n ? 0 : n;
    widget.querySelectorAll('.cg-dist').forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.rating) === rating)));
    render(STEP);
  }));

  const setMenu = (open) => {
    menu.hidden = !open;
    sortBtn.setAttribute('aria-expanded', String(open));
    if (open) (menu.querySelector('[aria-pressed="true"]') || menu.querySelector('button')).focus();
  };
  sortBtn.addEventListener('click', () => setMenu(menu.hidden));
  menu.querySelectorAll('[data-sort]').forEach((b) => b.addEventListener('click', () => {
    sort = b.dataset.sort;
    menu.querySelectorAll('[data-sort]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    setMenu(false);
    sortBtn.focus();
    render(STEP);
  }));
  menu.addEventListener('keydown', (e) => {
    const items = Array.from(menu.querySelectorAll('button'));
    const i = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); items[(i + (e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length].focus(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) { setMenu(false); sortBtn.focus(); } });
  document.addEventListener('click', (e) => { if (!menu.hidden && !e.target.closest('.cg-reviews__sort')) setMenu(false); });

  // « Écrire un avis » : formulaire de démonstration, validé dans le navigateur, rien n'est envoyé
  const write = widget.querySelector('[data-review-write]');
  let dialog = null;
  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'cg-review-dialog';
    dialog.setAttribute('aria-labelledby', 'cg-review-title');
    dialog.innerHTML = `
      <button type="button" class="cg-review-dialog__close" data-close aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
      <h2 id="cg-review-title">Écrire un avis</h2>
      <form novalidate>
        <fieldset class="cg-rate" aria-describedby="cg-rv-rate-error">
          <legend>Votre note</legend>
          ${[5, 4, 3, 2, 1].map((n) => `<input type="radio" name="note" id="cg-rv-${n}" value="${n}"><label for="cg-rv-${n}" title="${n} sur 5"><span aria-hidden="true">★</span><span class="visually-hidden">${n} étoile${n > 1 ? 's' : ''} sur 5</span></label>`).join('')}
        </fieldset>
        <p class="cg-field-error" id="cg-rv-rate-error" hidden></p>
        <label for="cg-rv-name">Prénom et initiale du nom</label>
        <input type="text" id="cg-rv-name" name="name" autocomplete="name" required>
        <label for="cg-rv-email">E-mail</label>
        <input type="email" id="cg-rv-email" name="email" autocomplete="email" required>
        <label for="cg-rv-text">Votre avis</label>
        <textarea id="cg-rv-text" name="text" rows="5" required></textarea>
        <p class="cg-review-dialog__note">Démonstration : rien n’est envoyé.</p>
        <button type="submit" class="btn">Envoyer mon avis</button>
      </form>
      <div class="cg-review-dialog__done" hidden>
        <p role="status">Merci ! Votre avis sera publié après vérification.</p>
        <button type="button" class="btn" data-close>Fermer</button>
      </div>`;
    document.body.append(dialog);
    const form = dialog.querySelector('form');
    const done = dialog.querySelector('.cg-review-dialog__done');
    const fail = (field, msg) => {
      const id = `${field.id || 'cg-rv-rate'}-error`;
      let err = dialog.querySelector(`#${id}`);
      if (!err) { err = document.createElement('p'); err.className = 'cg-field-error'; err.id = id; field.after(err); field.setAttribute('aria-describedby', id); }
      err.textContent = msg;
      err.hidden = !msg;
      if (field.matches('input, textarea')) field.setAttribute('aria-invalid', String(!!msg));
      return !msg;
    };
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const f = form.elements;
      const ok = [
        fail(dialog.querySelector('.cg-rate'), form.querySelector('[name="note"]:checked') ? '' : 'Choisissez une note.'),
        fail(f.name, f.name.value.trim().length >= 2 ? '' : 'Indiquez votre prénom.'),
        fail(f.email, /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email.value.trim()) ? '' : 'Saisissez un e-mail valide.'),
        fail(f.text, f.text.value.trim().length >= 10 ? '' : 'Votre avis doit faire au moins 10 caractères.'),
      ];
      if (ok.includes(false)) { (ok[0] ? form.querySelector('[aria-invalid="true"]') : form.querySelector('[name="note"]')).focus(); return; }
      form.hidden = true;
      done.hidden = false;
      done.querySelector('[data-close]').focus();
    });
    dialog.addEventListener('click', (e) => { if (e.target === dialog || e.target.closest('[data-close]')) dialog.close(); });
    dialog.addEventListener('close', () => write.focus());
  };
  write.addEventListener('click', () => {
    if (!dialog) build();
    const form = dialog.querySelector('form');
    form.reset();
    form.hidden = false;
    dialog.querySelector('.cg-review-dialog__done').hidden = true;
    dialog.querySelectorAll('.cg-field-error').forEach((p) => { p.hidden = true; });
    dialog.querySelectorAll('[aria-invalid]').forEach((x) => x.removeAttribute('aria-invalid'));
    dialog.showModal();
    dialog.querySelector('[name="note"]').focus();
  });
})();
